import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import Head from 'next/head';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import HeroBackground from '@/assets/escapes/hero-background.jpg';

import { ETabsColorVariant, ETabsVariant, Tabs } from '../common/Hero/Tabs';
import { EHomeSearchWidgetVariant, HomeSearchWidget } from '../ui/HomeSearchWidget';
import { SectionWrapper } from './Section/SectionWrapper';

export const Hero: React.FC = () => {
  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href={HeroBackground.src}
          type="image/jpeg"
          fetchPriority="high"
        />
      </Head>
      <SectionWrapper
        className="relative bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${HeroBackground.src})` }}>
        <div className="absolute inset-0 md:bg-gradient-to-r md:from-black/50 md:to-black/0 md:w-[65%] bg-black/30 md:bg-transparent" />
        <div className="flex flex-col w-full h-full my-auto mt-[85px] min-h-[280px] md:min-h-[590px] z-[1]">
          <Tabs tabVariant={ETabsVariant.RvSite} colorVariant={ETabsColorVariant.White} />
          <div className="md:mt-36">
            <Heading
              variant={EHeadingStyleVariant.H1}
              className="flex mt-4 font-normal text-white break-words md:block text-[32px] md:text-[64px]">
              <FormattedMessage
                defaultMessage="Outdoorsy Escapes:{br}RV delivery & resort stays in one booking"
                id="iHzumS"
                values={{
                  br: <br />,
                }}
              />
            </Heading>
          </div>
          {/* Hidden until we have escapes search page */}
          <div className="hidden mt-20">
            <HomeSearchWidget variant={EHomeSearchWidgetVariant.Escapes} />
          </div>
        </div>
      </SectionWrapper>
    </>
  );
};
